<template lang="pug">
VeeField(
  name="itemIdentifier"
  v-slot="{ field }"
)
  TxtRefined(
    v-bind="field"
    :model-value="title"
    @update:modelValue="handleUpdate"
    placeholder="e.g. 1 sofa and 4 chairs"
    input-id="title"
    label="Enter the items you are moving"
    label-position="border"
    label-bg="white"
    @focus="onInventoryTextClick"
    @blur="onBlur"
  )
  VeeErrorMessage(name="itemIdentifier")
    TextInputError.my-8
      | Enter some items ... anything!
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapActions } from "vuex"
import { SET_ITEM_IDENTIFIER_STATUS, SET_ITEM_IDENTIFIER_TEXT, SET_ITEMS } from "~/store/listing"
import { ITEM_SEARCH_LIMIT } from "~/constants/item"
import {
  ITEM_IDENTIFIER_HAS_ITEMS,
  ITEM_IDENTIFIER_HAS_NO_ITEMS,
  ITEM_IDENTIFIER_IN_PROGRESS,
  ITEM_IDENTIFIER_RESPONSE_ERROR
} from "~/constants/listing"

interface ComponentData {
  title: string
}

interface ItemsResponse {
  items: any[]
}

export default defineComponent({
  name: "ItemIdentifier",

  props: {
    block: {
      type: Object as () => Record<string, any>,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  data(): ComponentData {
    return {
      title: ""
    }
  },

  methods: {
    ...mapActions("listing", {
      setListingItems: SET_ITEMS,
      setItemIdentifierStatus: SET_ITEM_IDENTIFIER_STATUS,
      setItemIdentifierText: SET_ITEM_IDENTIFIER_TEXT
    }),

    handleUpdate(value) {
      this.title = value
    },

    // Track when the user clicks on the inventory text box
    onInventoryTextClick() {
      this.$snowplow.trackEvent({
        category: "inventory_text",
        action: "click"
      })
    },

    async onBlur(): Promise<void> {
      if (this.title.length <= ITEM_SEARCH_LIMIT) {
        return
      }

      // Track when the user enters text in the inventory text box
      this.$snowplow.trackEvent({
        category: "inventory_text",
        action: "entered",
        property: this.title
      })

      await this.setItemIdentifierText(this.title)
      await this.setItemIdentifierStatus(ITEM_IDENTIFIER_IN_PROGRESS)
      try {
        const { items } = await $fetch<Promise<ItemsResponse>>(
          `${this.$config.public.v4Host}/ng/item-identifier/text-to-quote/invoke?title=${this.title}`,
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          }
        )
        if (items && items.length > 0) {
          await this.setListingItems(items)
          await this.setItemIdentifierStatus(ITEM_IDENTIFIER_HAS_ITEMS)
          return
        }
        await this.setItemIdentifierStatus(ITEM_IDENTIFIER_HAS_NO_ITEMS)
      } catch (e) {
        await this.setItemIdentifierStatus(ITEM_IDENTIFIER_RESPONSE_ERROR)
      }
    }
  }
})
</script>
